import * as React from 'react';
import { CenterAlignedRow } from 'components/Styled/Layout/CenterAlignedRow';
import { Col, Form, Input, Row, Button, Descriptions, Icon } from 'antd';
import FormControl from 'components/Forms/FormControl';
import { FormComponentProps } from 'antd/lib/form';
import { withRouter, RouteComponentProps, NavLink } from 'react-router-dom';
import ISelectOption from 'components/Forms/SimpleSelect/ISelectOption';
import ValidationUtility from 'Core/ValidationUtility';
import UserProfileHandler from '../UserProfileHandler';
import { IResetPasswordCommandRequest, IChangePasswordCommandRequest, ClientDocumentType, ClientDocumentModel } from 'Core/Api/Api';
import FormItem from 'antd/lib/form/FormItem';
import NotificationService from 'Core/NotificationService';
import ConfigService from 'Core/ConfigService';
import Utility from 'Core/Utility';
import SimpleUpload from 'components/Forms/SimpleUpload';
import { startCase } from 'lodash';
import SimpleSelect from '../../Forms/SimpleSelect';
import Title from 'antd/lib/typography/Title';
import { BorderlessDescriptions } from '../../Offering/OfferingDetailsView';
import { WhiteBackgroundCard, singleColFormColSize } from '../../Forms/Form.Styled';


export interface Props extends FormComponentProps, RouteComponentProps {
    children?: React.ReactNode;
}

export interface State {
    profile?: any,
    documentTypes?: ISelectOption[]
}

var id = 0;
export class UserDocFormWithoutFormsAndRouter extends React.Component<Props, State> {
    handler: UserProfileHandler;
    constructor(props: Props) {
        super(props);

        this.state = {};
        this.handler = new UserProfileHandler(props);
    }

    componentDidMount() {
        this.getDocumentTypes();
        this.getProfileInfo();
    }

    getDocumentTypes() {
        var documentTypes: ISelectOption[] = [];
        Utility.enumToMap(ClientDocumentType).forEach((x, y) => documentTypes.push({ text: startCase(x), value: y }));
        this.setState({ documentTypes });
    }

    getProfileInfo() {
        this.handler.GetProfileInfo({}).then(
            x => {
                this.setState({ profile: x });
            },
            x => NotificationService.error(x.message)
        )
    }

    onSubmit = (e: React.SyntheticEvent) => {
        e.preventDefault();
        this.props.form.validateFields((error, values: IChangePasswordCommandRequest) => {
            if (error) {
                return;
            }

            this.handler.ChangePassword(values).then(() => {
                this.props.history.push('/login');
                NotificationService.success('Password has been updated');
            });
        });
    };

    remove = k => {
        const { form } = this.props;
        // can use data-binding to get
        const keys = form.getFieldValue('keys');
        // We need at least one passenger
        if (keys.length === 1) {
            return;
        }

        // can use data-binding to set
        form.setFieldsValue({
            keys: keys.filter(key => key !== k),
        });
    };

    add = () => {
        const { form } = this.props;
        // can use data-binding to get
        const keys = form.getFieldValue('keys');
        const nextKeys = keys.concat(id++);
        // can use data-binding to set
        // important! notify form to detect changes
        form.setFieldsValue({
            keys: nextKeys,
        });
    };

    handleSubmit = e => {
        e.preventDefault();
        this.props.form.validateFields((err, values) => {
            if (!err) {
                const { keys, desc, docs, comment } = values;
                console.log('Received values of form: ', values);
                console.log('Merged desc values:', keys.map(key => desc[key]));
                console.log('Merged doc values:', keys.map(key => docs[key]));


                var test = keys.map(key => {
                    var m = new ClientDocumentModel();
                    m.documentType = desc[key];
                    m.documents = (docs[key] ?? [undefined])[0] as any;
                    m.comments = comment[key];
                    return m;
                });

                var document = { document: test };
                //document.document = test;

                //var model = new UploadUserDocumentsCommandRequest();
                //model.documents = test;
                console.log(test);
                console.log(document);
                this.handler.UploadDocuments(document).then(() => {
                    this.props.history.push('/user-profile');
                    NotificationService.success('Document Uploaded successfully');
                });;
            } else {
                console.log(err);
            }

        });
    };


    render() {
        const { getFieldDecorator, getFieldValue } = this.props.form;
        const formItemLayout = {
            labelCol: {
                xs: { span: 24 },
                sm: { span: 4 },
            },
            wrapperCol: {
                xs: { span: 24 },
                sm: { span: 20 },
            },
        };
        const formItemLayoutWithOutLabel = {
            wrapperCol: {
                xs: { span: 24, offset: 0 },
                sm: { span: 20, offset: 4 },
            },
        };
        getFieldDecorator('keys', { initialValue: [] });
        const keys = getFieldValue('keys');
        const formItems = keys.map((k, index) => (
            <Row> <Col> <Form.Item
                {...(index === 0 ? formItemLayout : formItemLayout)}
                label={'Document Type'}
                required={true}
                key={"desc_" + k}
            >
                {getFieldDecorator(`desc[${k}]`, {

                    rules: [...ValidationUtility.required('Document Type is required'),
                    ],
                })(
                    <SimpleSelect
                        loading={!this.state.documentTypes}
                        options={this.state.documentTypes}

                    />
                )}

            </Form.Item>
           
                <Form.Item
                    {...(index === 0 ? formItemLayout : formItemLayout)}
                    label={'Document'}
                    required={true}
                    key={"doc_" + k}
                >
                    {getFieldDecorator(`docs[${k}]`, {
                        validateTrigger: ['onChange', 'onBlur'],
                        rules: [...ValidationUtility.required('Document Upload is required'),
                        ],
                    })(
                        <SimpleUpload accept="image/*, .png, .jpg, .jpeg">
                            <Button>
                                <Icon type="upload" /> Click to Upload
                            </Button>
                        </SimpleUpload>)}
                    {index >= 1 ? (
                        <Icon
                            className="dynamic-delete-button"
                            type="minus-circle-o"
                            onClick={() => this.remove(k)}
                        />
                    ) : null}
                </Form.Item>

                <Form.Item
                    {...(index === 0 ? formItemLayout : formItemLayout)}
                    label={'Comments'}
                    required={false}
                    key={"comment_" + k}
                >
                    {getFieldDecorator(`comment[${k}]`, {

                        rules: [

                        ],
                    })(
                        <Input />
                    )}

                </Form.Item>
                </Col>
            </Row>
        ));
        var passwordValidations = ValidationUtility.password;
        var compareValidations = ValidationUtility.compare;
        return (
            <Row type="flex" justify="center">
                <Col>
                    <WhiteBackgroundCard>

                        <Row>
                            <Col span={24}>
                                <Row type="flex">
                                    <Col style={{ paddingTop: "75px" }}>
                                        <Title>User Profile &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</Title>

                                        <Form onSubmit={this.handleSubmit} >
                                            
                                            {formItems}
                                            <Form.Item {...formItemLayoutWithOutLabel}>
                                                <Button type="dashed" onClick={this.add} style={{ width: '60%' }}>
                                                    <Icon type="plus" /> Add Document
                                                </Button>
                                            </Form.Item>
                                            <Form.Item {...formItemLayoutWithOutLabel}>
                                                <Button type="primary" htmlType="submit">
                                                    Submit
                                                </Button>
                                            </Form.Item>
                                        </Form>
                                      
                                    </Col>
                                </Row>
                            </Col>

                        </Row>
                    </WhiteBackgroundCard>

                </Col>

            </Row>
        );
    }
}

const UserDocFormWithoutRouter = Form.create<Props>({
    name: 'UserDocForm',
})(UserDocFormWithoutFormsAndRouter);

const UserDocForm = withRouter(UserDocFormWithoutRouter);

export default UserDocForm;
